import { StyleSheet, Platform } from 'react-native';

const isWeb = Platform.OS === 'web';

export const buttonStyle = StyleSheet.create({
    primaryButton: {
        margin: isWeb ? 16 : 12,
        minHeight: isWeb ? 44 : 40,
    },
    buttonWithTopMargin: {
        marginTop: isWeb ? 16 : 12
    },
})